import { GET_TIMEZONES } from "constants/timezones";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_TIMEZONES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
